/**
 * The old Edit Container page saved to the wrong place (the old database's
 * edit_customer), so a container renamed there was never renamed. Its
 * address now opens the container's real form on the Containers screen -
 * the one whose rename carries to the orders and everywhere else.
 */

import { Navigate, useParams } from "react-router-dom";

function OpenInList() {
  const { id } = useParams();

  return <Navigate to={id ? `/containers?open=${id}` : "/containers"} replace />;
}

export default OpenInList;
